import { langName, MAX_PARTICIPANTS } from "@/lib/langs";

export const Participants = ({ room, online, speaking, me }) => (
  <div data-testid="room-participants">
    <div className="flex items-center justify-between border-b border-border px-5 py-3">
      <span className="eyebrow">Participants</span>
      <span className="mono-label">{online.length} online · {room.participants.length}/{MAX_PARTICIPANTS}</span>
    </div>
    <ul>
      {room.participants.map((p) => {
        const on = online.includes(p.user_id);
        const talk = speaking[p.user_id];
        return (
          <li key={p.user_id} className="flex items-center gap-3 border-b border-border px-5 py-3 last:border-0" data-testid={`participant-${p.user_id}`}>
            <span className={`relative flex h-9 w-9 items-center justify-center rounded-full border font-display text-sm font-bold transition-shadow duration-300 ${talk ? "border-[color:var(--au-green)] shadow-[0_0_14px_var(--au-green)]" : "border-border"}`}>
              {p.name?.[0]?.toUpperCase()}
              <span className={`absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-2 border-background ${on ? "bg-[color:var(--au-green)]" : "bg-muted-foreground/40"}`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-medium">{p.name}{p.user_id === me && " (you)"}{p.user_id === room.host_id && <span className="ml-2 font-mono text-[10px] text-[color:var(--au-cyan)]">HOST</span>}</div>
              <div className="font-mono text-[11px] text-muted-foreground">
                [{p.language.toUpperCase()}] {langName(p.language)}
                {talk && <span className="ml-2 text-[color:var(--au-green)]">● SPEAKING</span>}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);
